import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import axios from 'axios';
import { Card, Table } from 'semantic-ui-react';
import {
  compose,
} from 'recompose';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';

class InfluencerQuestionnaire extends Component {
  constructor() {
    super();
    this.state = { loading: true };
  }

  componentWillMount = () => {
    const {
      influencer,
    } = this.props;

    console.log(this.props);

    this.setState({
      loading: true,
    });
    axios.get(`https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/typeform/${influencer.createdDate}/${influencer.id}`)
      .then(response => {
        const data = response.data;
        console.log(data);
        return this.setState({ data, loading: false });
      })
      .catch(err => {
        this.setState({
          loading: false,
          error: err,
        });
      });
  }

  render() {
    const {
      data,
    } = this.state;

    return (
      <div style={{ padding: '20px' }}>
        <Card fluid>
          <Card.Content>
            <Card.Header>
          Questionnaire Results
            </Card.Header>
          </Card.Content>
          <Card.Content>
            <Table textAlign="center">
              <Table.Body>
                {_.map(data, ({ question, answer }) => <Table.Row>
                  <Table.Cell textAlign="left" >{question}</Table.Cell>
                  <Table.Cell>{answer}</Table.Cell>
                </Table.Row>)}
              </Table.Body>
            </Table>
          </Card.Content>
        </Card>
      </div>

    );
  }
}

InfluencerQuestionnaire.propTypes = {
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(InfluencerQuestionnaire);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-questionnaire/index.js
 **/